import React, { useState } from 'react'
import './sections.scss'

import Header from '../../../components/header/Header'
import Banner from './Banner'
import Features from './Feature'
import HowItWorks from './how_it_works'
  import WhoTikBoxIsFor from './who_tikbox_is_for'
// import Services from './Services'
import SignUpModal from './SignUp'
import SignInModal from './SignIn'
import TrustDifferentiation from './trust_differentiation'
import TestimonialsMain from './testimonials_main'
import FinalBrandCta from './final_brand_cta'
const LandingPageSections = () => {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false)
  const [isSignInOpen, setIsSignInOpen] = useState(false)
  return (
    <>
      <Header
        setIsSignUpOpen={setIsSignUpOpen}
        setIsSignInOpen={setIsSignInOpen}
      />
      <Banner setIsSignUpOpen={setIsSignUpOpen} />
      {/* <Features /> */}
      <HowItWorks />
      <WhoTikBoxIsFor />
      <TrustDifferentiation />
      <TestimonialsMain />
      
      <FinalBrandCta setIsSignUpOpen={setIsSignUpOpen}
       />
      {/* <Services setIsSignUpOpen={setIsSignUpOpen} /> */}
      {isSignUpOpen && (
        <SignUpModal
          setIsSignUpOpen={setIsSignUpOpen}
          setIsSignInOpen={setIsSignInOpen}
        />
      )}
      {isSignInOpen && (
        <SignInModal
          setIsSignUpOpen={setIsSignUpOpen}
          setIsSignInOpen={setIsSignInOpen}
        />
      )}
    </>
  )
}

export default LandingPageSections
